<template>
  <aside :class="['sidebar', { collapsed: isCollapsed }]">
    <!-- Logo 区域 -->
    <div class="sidebar-header">
      <div class="logo-icon"><i class="fas fa-broadcast-tower"></i></div>
      <transition name="fade">
        <div v-show="!isCollapsed" class="logo-text">
          <h1>格力之声</h1>
          <span>工作平台</span>
        </div>
      </transition>
      <button class="collapse-btn" @click="toggleCollapse" :title="isCollapsed ? '展开' : '收起'">
        <i :class="isCollapsed ? 'fas fa-chevron-right' : 'fas fa-chevron-left'"></i>
      </button>
    </div>

    <!-- 菜单列表 -->
    <nav class="sidebar-menu">
      <router-link
        v-for="item in menuItems"
        :key="item.path"
        :to="item.path"
        class="menu-item"
        :class="{ active: isActive(item.path) }"
        :title="item.title">
        <div class="menu-icon"><i :class="item.icon"></i></div>
        <transition name="fade">
          <div v-show="!isCollapsed" class="menu-text">
            <div class="menu-title">{{ item.title }}</div>
            <div class="menu-desc">{{ item.desc }}</div>
          </div>
        </transition>
        <div class="menu-arrow" v-show="!isCollapsed">
          <i class="fas fa-chevron-right"></i>
        </div>
      </router-link>
    </nav>

    <!-- 底部信息 -->
    <div class="sidebar-footer" v-show="!isCollapsed">
      <div class="footer-content">
        <i class="fas fa-circle-info"></i>
        <span>{{ currentWeekday }}</span>
      </div>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'TheSidebar',
  data() {
    return {
      isCollapsed: true,
      isMobile: false,
      menuItems: [
        { path: '/', title: '首页', desc: '功能导航', icon: 'fas fa-house' },
        { path: '/write', title: '撰稿', desc: '广播稿件撰写', icon: 'fas fa-pen-to-square' },
        { path: '/schedule', title: '排班', desc: '广播员排班', icon: 'fas fa-calendar-days' },
        { path: '/music', title: '音乐', desc: '开始/结束音乐控制', icon: 'fas fa-music' }
      ]
    };
  },
  computed: {
    currentWeekday() {
      const weekdays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
      return weekdays[new Date().getDay()];
    }
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    checkMobile() {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth <= 768;
      // 进入移动端时强制展开（顶部导航栏需要显示文字）
      if (this.isMobile) {
        this.isCollapsed = false;
      } else if (wasMobile && !this.isMobile) {
        // 从移动端切回桌面端，恢复收起
        this.isCollapsed = true;
        this.$emit('toggle', this.isCollapsed);
      }
    },
    toggleCollapse() {
      // 移动端不响应折叠按钮
      if (this.isMobile) return;
      this.isCollapsed = !this.isCollapsed;
      this.$emit('toggle', this.isCollapsed);
    },
    isActive(path) {
      return this.$route.path === path;
    }
  }
};
</script>

<style scoped>
.sidebar {
  width: 240px;
  height: 100vh;
  background: linear-gradient(180deg, #1e293b 0%, #334155 100%);
  color: #fff;
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  box-shadow: 2px 0 20px rgba(0, 0, 0, 0.15);
  transition: width 0.3s ease;
  overflow: hidden;
}
.sidebar.collapsed {
  width: 72px;
}
/* ===== Logo 区域 ===== */
.sidebar-header {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  gap: 12px;
  position: relative;
  min-height: 76px;
}
.logo-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #b45309, #d97706);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #fff;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(180, 83, 9, 0.4);
}
.logo-text {
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
}
.logo-text h1 {
  font-family: 'SimHei', 'Microsoft YaHei', 'PingFang SC', sans-serif;
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: 0.5px;
  line-height: 1.3;
}
.logo-text span {
  font-size: 0.72rem;
  color: #b45309;
  font-weight: 600;
}
.collapse-btn {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.65rem;
  transition: all 0.2s;
}
.collapse-btn:hover {
  background: rgba(180, 83, 9, 0.3);
  border-color: #b45309;
}
.sidebar.collapsed .collapse-btn {
  right: 4px;
}
/* ===== 菜单 ===== */
.sidebar-menu {
  flex: 1;
  padding: 16px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow-y: auto;
}
.menu-item {
  display: flex;
  align-items: center;
  padding: 12px 14px;
  border-radius: 8px;
  color: #cbd5e1;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.25s;
  position: relative;
  gap: 14px;
}
.menu-item:hover {
  background: rgba(255, 255, 255, 0.06);
  color: #fff;
}
.menu-item.active {
  background: linear-gradient(135deg, rgba(180, 83, 9, 0.2), rgba(217, 119, 6, 0.1));
  color: #fbbf24;
}
.menu-item.active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 8px;
  bottom: 8px;
  width: 3px;
  background: #b45309;
  border-radius: 0 3px 3px 0;
}
.menu-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.05rem;
  flex-shrink: 0;
}
.menu-text {
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
}
.menu-title {
  font-size: 0.9rem;
  font-weight: 600;
  line-height: 1.4;
}
.menu-desc {
  font-size: 0.72rem;
  color: #94a3b8;
  margin-top: 2px;
}
.menu-item.active .menu-desc {
  color: rgba(251, 191, 36, 0.7);
}
.menu-arrow {
  font-size: 0.7rem;
  color: #64748b;
  opacity: 0;
  transition: all 0.25s;
}
.menu-item:hover .menu-arrow {
  opacity: 1;
  transform: translateX(3px);
}
.menu-item.active .menu-arrow {
  color: #fbbf24;
  opacity: 1;
}
/* 折叠态 tooltip */
.sidebar.collapsed .menu-item {
  justify-content: center;
  padding: 12px 0;
}
/* ===== 底部 ===== */
.sidebar-footer {
  padding: 14px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}
.footer-content {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.8rem;
  color: #94a3b8;
}
.footer-content i {
  color: #b45309;
}
/* ===== 过渡动画 ===== */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
/* ===== 滚动条 ===== */
.sidebar-menu::-webkit-scrollbar {
  width: 4px;
}
.sidebar-menu::-webkit-scrollbar-track {
  background: transparent;
}
.sidebar-menu::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 2px;
}
.sidebar-menu::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.25);
}
/* ===== 响应式：移动端改为顶部导航栏 ===== */
@media (max-width: 768px) {
  .sidebar {
    width: 100%;
    height: 56px;
    flex-direction: row;
    align-items: center;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
    overflow: visible;
    transition: none;
  }
  /* Logo 区域精简 */
  .sidebar-header {
    border-bottom: none;
    border-right: 1px solid rgba(255, 255, 255, 0.08);
    padding: 0 12px;
    min-height: 56px;
    flex-shrink: 0;
    gap: 8px;
  }
  .logo-icon {
    width: 32px;
    height: 32px;
    font-size: 14px;
  }
  .logo-text h1 {
    font-size: 0.85rem;
  }
  .logo-text span {
    font-size: 0.62rem;
  }
  .collapse-btn {
    display: none;
  }
  /* 菜单水平排列 */
  .sidebar-menu {
    flex-direction: row;
    padding: 0 4px;
    gap: 0;
    overflow-x: auto;
    flex: 1;
    height: 56px;
    align-items: center;
  }
  .sidebar-menu::-webkit-scrollbar {
    display: none;
  }
  .menu-item {
    flex-direction: row;
    align-items: center;
    padding: 8px 10px;
    gap: 6px;
    border-radius: 6px;
    flex-shrink: 0;
    white-space: nowrap;
  }
  .menu-icon {
    width: 20px;
    height: 20px;
    font-size: 0.9rem;
  }
  .menu-text {
    display: flex;
    align-items: center;
  }
  .menu-title {
    font-size: 0.8rem;
  }
  .menu-desc {
    display: none;
  }
  .menu-arrow {
    display: none;
  }
  .sidebar-footer {
    display: none;
  }
  /* 高亮改为底部边线 */
  .menu-item.active::before {
    display: none;
  }
  .menu-item.active {
    border-bottom: 2px solid #fbbf24;
    border-radius: 4px;
    background: rgba(251, 191, 36, 0.08);
  }
}
</style>
